<div class="progress">
	<span class="progress-value">
		@if (type() === 'percent') {
			{{ progressPercent() }}%
		} @else {
			{{ count() }}/{{ total() }}
		}
	</span>

	<div
		aria-busy="true"
		aria-live="polite"
		class="progress-bar bg-info"
		role="progressbar"
		[ngClass]="
			progressPercent() >= 100
				? ''
				: 'progress-bar-striped progress-bar-animated'
		"
		[style.width]="progressPercent() + '%'"
	></div>
</div>
